import i18n from 'i18next';
export const useResponseErrorParser = () => {
    const parseResponse = (errors) => {
        if (errors.some(error => error.message.includes('(0) Неверные исходные данные:') &&
            error.message.includes('уже используется!'))) {
            return i18n.t('The specified email is already in use, please log in to your personal account using the data you provided during registration or restore your card number/password', { ns: 'Loyalty' });
        }
        return errors[0].message;
    };
    return { parseResponse };
};
